import * as c from "./constant";

export const setLoadingState = (state) => ({
  type: c.SET_LOADING_STATE,
  payload: state,
});

export const setErrorType = (type) => ({
  type: c.SET_ERROR_TYPE,
  payload: type,
});

export const setTotalUploadedCardsCount = (count) => ({
  type: c.SET_TOTAL_UPLOADED_CARDS_COUNT,
  payload: count,
});

export const setTotalErrorCardsCount = (count) => ({
  type: c.SET_TOTAL_ERROR_CARDS_COUNT,
  payload: count,
});

export const setTotalSuccessCardsCount = (count) => ({
  type: c.SET_TOTAL_SUCCESS_CARDS_COUNT,
  payload: count,
});

export const setErrorCards = (cards) => ({
  type: c.SET_ERROR_CARDS,
  payload: cards,
});

export const doResetCards = () => ({ type: c.RESET_CARDS });

export const doRemoveErrorCard = (idx) => ({
  type: c.REMOVE_ERROR_CARD,
  payload: idx,
});
